import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Grid } from "@material-ui/core";
import Backlink from "../../common/e_backLink/e_back_link";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { routePaths } from "../../config/route-paths";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  blueText: {
    color: theme.palette.ePrimary?.base,
    fontWeight:"bold",
    "&:hover": {
        color: theme.palette.ePrimary?.hover,
    },
  },
  underlineText:{
    textDecoration:"underline"
  }
}));

export default function E_Alerts_Notification_Header() {
  let classes = useStyle();
  const {t:labels, ready: labelReady}=useTranslation("label-E_ALERTS_AND_NOTIFICATION")
  const {t:content, ready: contentReady}=useTranslation("content-E_ALERTS_AND_NOTIFICATIONS")

  let heading= contentReady ? content("E_ALERTS_AND_NOTIFICATIONS_PAGE_SUBTITLE").answer?.replace(
    "***",
    "<a href=" + routePaths.SELF_HELP + " class='&&&'>").replace("***", "</a>").replace("&&&",`${classes.blueText} ${classes.underlineText}`) : ''
                
  return (
    <Grid container>
      <Grid item xs={12}>
        <Backlink />
      </Grid>
      <Grid item xs={12}>
      {
        labelReady ?
        <Typography variant="h5" className={classes.blueText}>
          {labels("E_ALERTS_NOTIFICATION_ANNOUNCEMENT_TITLE")}
        </Typography>
        : <Skeleton />
      }
      </Grid>
      <Grid item>
        <Typography
          variant="subtitle2"
          dangerouslySetInnerHTML={{
            __html:heading
          }}
        />
      </Grid>
    </Grid>
  );
}
